<template>
    <div v-show="showTaskTable">
        <TaskTable :tasks="tasks" :taskFiltered="taskFiltered" :zones="zones" :groups="groups"
            :constructionWorks="constructionWorks" :activities="activities" @setTasks="setTasks" @addTask="addTask"
            @setSelectedZone="setSelectedZone" @filterTasks="filterTasks" :gantt="gantt" @setGantt="setGantt"
            @setSelectedGroups="setSelectedGroups" @updateEquipmentGroup="updateEquipmentGroup" :readonly="readonly"
            :projectStart="projectStart" :selectedZone="selectedZone" :projectEnd="projectEnd" @openCWAct="openCWAct"
            :projectId="projectId" />
    </div>
    <!-- <Divider align="center" v-if="!readonly">
        <Button v-if="showTaskTable" icon="pi pi-angle-double-up" class="p-button-rounded p-button-outlined"
            @click="showTaskTable = false"></Button>
        <Button v-else icon="pi pi-angle-double-down" class="p-button-rounded p-button-outlined"
            @click="showTaskTable = true"></Button>
    </Divider> -->
    <!-- <GanttChart v-if="tasks.length > 0" v-show="showGantt" :gantt="gantt" :tasks="tasks" :groups="groups"
        :taskFiltered="taskFiltered" @setGantt="setGantt" @setSelectedGroups="setSelectedGroups"
        @filterTasks="filterTasks" />
    <Divider align="center" v-show="tasks.length > 0 && taskFiltered.length > 0">
        <Button v-if="showGantt" icon="pi pi-angle-double-up" class="p-button-rounded p-button-outlined"
            @click="showGantt = false"></Button>
        <Button v-else icon="pi pi-angle-double-down" class="p-button-rounded p-button-outlined"
            @click="showGantt = true"></Button>
    </Divider> -->
</template>

<script>
import GanttChart from './GanttChart.vue';
import UploadFile from '@/components/UploadFile.vue';
import TaskTable from './TaskTable.vue';

export default {
    name: 'Schedule',
    components: {
        GanttChart,
        UploadFile,
        TaskTable
    },
    props: {
        tasks: Array,
        zones: Array,
        groups: Array,
        constructionWorks: Array,
        activities: Array,
        readonly: Boolean,
        projectStart: Date,
        projectEnd: Date,
        selectedZone: Object,
        projectId: Number
    },
    data() {
        return {
            showTaskTable: true,
            showGantt: true,
            taskFiltered: [],
            file: [],
            gantt: null,

            selectedGroups: [],
            // selectedZone: this.zones.length > 0 ? this.zones[0].id : "",
        }
    },
    beforeMount() {
        this.filterTasks(this.selectedZone);
    },
    mounted() {
        this.filterTasks(this.selectedZone);
    },
    watch: {
        tasks() {
            this.filterTasks(this.selectedZone);
        }
    },
    methods: {
        setGantt(gantt) {
            this.gantt = gantt;
        },
        setTasks(tasks) {
            this.$emit('setTasks', tasks);
        },
        addTask(task) {
            this.$emit('addTask', task);
        },
        openCWAct() {
            this.$emit('openCWAct');
        },
        setSelectedGroups(groups) {
            if (groups.join() != this.selectedGroups.join()) {
                this.selectedGroups = groups;
                this.filterTasks(this.selectedZone);
            }
        },
        setSelectedZone(zone) {
            if (zone.id != this.selectedZone.id) {
                this.$emit('setSelectedZone', zone);
                this.filterTasks(zone);
            }
        },
        filterTasks(zone) {
            let props = this;
            if (!zone) return;
            if (zone.id == "") {
                this.taskFiltered = this.tasks;
            }
            else if (this.selectedGroups.length == 0) {
                this.taskFiltered = this.tasks.filter(t => t.zone == zone.id);
            }
            else {
                this.taskFiltered = this.tasks.filter(t => props.selectedGroups.includes(t.group)).filter(t => t.zone == zone.id);
            }
            if (this.gantt && this.taskFiltered.length > 0) {
                this.gantt.refresh(this.taskFiltered);
            }
        },
        updateEquipmentGroup(task) {
            this.$emit('updateEquipmentGroup', task);
        }
    }
}
</script>

<style scoped>
.card {
    width: 80vw;
    height: 80vh;
}

.view-group {
    margin-top: 0.75rem;
    text-align: left;
}
</style>
<style>
.p-dropdown {
    height: 35px;
}

.p-dropdown-label {
    font-size: 0.875rem !important;
    line-height: 15px;
}

.p-dropdown-trigger-icon {
    font-size: 0.875rem;
}
</style>